import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject, OnDestroy, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { ScreensizeStateService } from '../../../../state-management/services/screensize-state.service';
import { WebsiteStateService } from '../../../../state-management/services/website-state.service';
import { CoordinatesSystem, ScreenWidthBreakpoints } from '../../../../state-management/model/enums/screen-size.enums';

@Component({
  selector: 'app-stripe-pricing-table',
  imports: [
    CommonModule
  ],
  templateUrl: './stripe-pricing-table.component.html',
  styleUrl: './stripe-pricing-table.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class StripePricingTableComponent implements OnInit, OnDestroy {
  private scriptElement?: HTMLScriptElement;

  public scriptLoaded: boolean = false;
  public isLargeScreen$ = this.screenSize.isScreenSizes(CoordinatesSystem.ScreenWidth, [ScreenWidthBreakpoints.Large, ScreenWidthBreakpoints.XLarge]);
  public shopId = this.stateService.shopId

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private screenSize: ScreensizeStateService,
    private stateService: WebsiteStateService,
    private renderer: Renderer2
  ) { }

  ngOnInit() {
    this.loadStripeScript();
  }

  ngOnDestroy() {
    this.removeStripeScript();
  }

  private loadStripeScript() {
    if (!isPlatformBrowser(this.platformId)) return;

    if (document.querySelector('script[src="https://js.stripe.com/v3/pricing-table.js"]')) {
      this.onStripeScriptLoaded();
    } else {

      this.scriptElement = this.renderer.createElement('script');
      if (!this.scriptElement) {
        return;
      }
      this.scriptElement.src = 'https://js.stripe.com/v3/pricing-table.js';
      this.scriptElement.async = true;
      this.scriptElement.onload = () => this.onStripeScriptLoaded();
      document.body.appendChild(this.scriptElement);
    }
  }

  private removeStripeScript() {
    if (!this.scriptElement) {
      return;
    }
    document.body.removeChild(this.scriptElement);
  }

  private onStripeScriptLoaded() {
    this.scriptLoaded = true; // Setze das Flag auf true, wenn das Skript geladen ist
  }
}
